import baseDictionaries from 'moodleDir/procollege/lib/vue/default-block-root.vue';

export default {
  routes: [
    {
      path: '/',
      component:baseDictionaries,
      name:'baseDictionaries'
    },
  ]
};
